import fetch from 'isomorphic-fetch';
import Api from '../../../../api';

const dependencies = {
  fetch,
  bkmdApi: Api,
};

export default dependencies;
